module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#star",
      toString: function () {
        return this.url;
      }
    }